module.exports = __webpack_public_path__ + "static/img/ship-shuttle_256.6c8d949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ship-shuttle_256.png
// module id = uKAl
// module chunks = 0